"use client";

import React from "react";
import ChipGroup from "@/components/creator/ChipGroup";
import { INTERESTS, STYLES } from "@/app/constants/creatorNetwork";
import type { CreatorApplication } from "@/types/creatorNetwork";

type StepProps = {
  data: CreatorApplication;
  onUpdate: (patch: Partial<CreatorApplication>) => void;
  errors: Record<string, string | null | undefined>;
};

const YES_NO = [
  { value: "yes", label: "Yes" },
  { value: "no", label: "No" },
];

const boolToChip = (value: boolean | null) =>
  value === null ? "" : value ? "yes" : "no";

export default function StepContent({ data, onUpdate, errors }: StepProps) {
  return (
    <div>
      <h3 className="step-title text-white text-2xl font-bold mb-1">What you create</h3>
      <p className="text-white/60 mb-6">Help us match you to the right briefs.</p>

      <div className="mb-6">
        <ChipGroup
          label="Content interests"
          hint="Select all that apply"
          options={INTERESTS}
          mode="multi"
          value={data.interests}
          onChange={(v) => onUpdate({ interests: v as string[] })}
          otherValue={data.interestsOther}
          onOtherChange={(v) => onUpdate({ interestsOther: v })}
          error={errors.interests}
        />
      </div>

      <div className="mb-6">
        <ChipGroup
          label="Content style"
          hint="Select all that apply"
          options={STYLES}
          mode="multi"
          value={data.styles}
          onChange={(v) => onUpdate({ styles: v as string[] })}
          error={errors.styles}
        />
      </div>

      <div className="mb-6">
        <ChipGroup
          label="Are you comfortable showing your face on camera?"
          options={YES_NO}
          mode="single"
          value={boolToChip(data.showFace)}
          onChange={(v) => onUpdate({ showFace: v === "" ? null : v === "yes" })}
          error={errors.showFace}
        />
      </div>

      <div>
        <ChipGroup
          label="Are you UGC-only? (content for brand use, not posted on your own feed)"
          options={YES_NO}
          mode="single"
          value={boolToChip(data.ugcOnly)}
          onChange={(v) => onUpdate({ ugcOnly: v === "" ? null : v === "yes" })}
          error={errors.ugcOnly}
        />
      </div>
    </div>
  );
}
